export default __webpack_public_path__ + "static/toe-4cb4c31b2c613149158dc29887e5d63f.jpg";